export const CLASSES_NOT_STARTED_MESSAGE = 'No Classes Created'
export const NOT_STARTED_MESSAGE = 'not started'
export const MAX_UNITS_FOR_HEADER = 4
